/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The hosted Stripe Customer Portal URL for the FE to open.
 */
export interface BillingPortalSessionResponse {
  /** Short-lived, single-use Stripe Customer Portal URL. */
  url: string;
}
